<template>
    <div>
        <v-card elevation="0" outlined class="px-8 py-4 mb-4 year-position-card">
            <v-row>
                <v-col sm="12" md="4" class="d-flex align-center">
                    <span class="d-flex text-uppercase font-weight-medium flex-grow-0 year-position-card-title">
                        {{ externalAccount.account.name }}
                    </span>
                </v-col>
                <v-col cols="12" sm="12" md="7" class="d-flex align-center">
                    <v-list dense class="d-flex year-position-list flex-grow-1 flex-column flex-sm-row flex-md-row flex-lg-row flex-xl-row" color="transparent">
                        <v-list-item class="d-flex flex-column">
                            <v-list-item-content class="grey--text text-uppercase pa-0 pb-3 align-self-start align-start">Account Name</v-list-item-content>
                            <v-list-item-content class="grey--text--darken-1 pa-0 align-self-start align-start">{{ externalAccount.account.name }}</v-list-item-content>
                        </v-list-item>
                        <v-list-item class="d-flex flex-column">
                            <v-list-item-content class="grey--text text-uppercase pa-0 pb-3 align-self-start align-start">Account Number</v-list-item-content>
                            <v-list-item-content class="grey--text--darken-1 pa-0 align-self-start align-start">{{ externalAccount.account.account_number }}</v-list-item-content>
                        </v-list-item>
                        <v-list-item class="d-flex flex-column">
                            <v-list-item-content class="grey--text text-uppercase pa-0 pb-3 align-self-start align-start">Account Type</v-list-item-content>
                            <v-list-item-content class="grey--text--darken-1 pa-0 align-self-start align-start">{{ getAccountType(positions.types[externalAccount.account.account_type]) }}</v-list-item-content>
                        </v-list-item>
                        <v-list-item class="d-flex flex-column">
                            <v-list-item-content class="grey--text text-uppercase pa-0 pb-3 align-self-start align-start">Custodian</v-list-item-content>
                            <v-list-item-content class="grey--text--darken-1 pa-0 align-self-start align-start">{{ externalAccount.account.iav_account.company_name }}</v-list-item-content>
                        </v-list-item>
                        <v-list-item class="d-flex flex-column">
                            <v-list-item-content class="grey--text text-uppercase pa-0 pb-3 align-self-start align-start">Balance</v-list-item-content>
                            <v-list-item-content class="grey--text--darken-1 pa-0 align-self-start align-start">{{ externalAccount.account.value | money }}</v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-col>
                <v-col sm="12" md="1" class="d-flex align-center justify-end">
                    <v-btn @click="show = !show" class="d-flex white--text" color="#1D5BE5" rounded depressed small>
                        <template v-if="!show">Show</template>
                        <template v-if="show">Hide</template>
                    </v-btn>
                </v-col>
            </v-row>


            <v-row v-if="show">

                <v-col>
                    <br  />
                    <v-card elevation="0" color="transparent">
                        <v-simple-table class="year-position-table">
                            <tbody>
                            <tr>
                                <th></th>
                                <th>
                                    Holdings
                                </th>
                                <th>
                                    Units
                                </th>
                                <th>
                                    Price
                                </th>
                                <th>
                                    Cost
                                </th>
                                <th>
                                    Value
                                </th>
                                <th>
                                    Gain/Loss
                                </th>
                            </tr>
                            </tbody>
                            <tbody v-for="(positionsLoop, investmentType) in externalAccount.positions" :key="'positionloop-'+investmentType">
                            <tr>
                                <th class="tab-subheading" colspan="8">
                                    {{ investmentType === null ? 'Other' : investmentType }}
                                </th>
                            </tr>
                            <tr v-for="(position, positionIndex) in positionsLoop" :key="'position-'+positionIndex">
                                <td class="text-left w-30">{{ position.name }} ({{ position.symbol }})</td>
                                <td>{{ position.holding | percentage }}</td>
                                <td>{{ position.balance }}</td>
                                <td>{{ position.price | money }}</td>
                                <td>{{ position.cost | money }}</td>
                                <td>{{ position.value | money }}</td>
                                <td>{{ position.gainLoss | money }}</td>
                            </tr>
                            <tr>
                                <td>
                                    Totals
                                </td>
                                <td>
                                    <strong>{{ externalAccount.sumsByCategory[investmentType].holdings | percentage }}</strong>
                                </td>
                                <td colspan="2"></td>
                                <td>
                                    <strong>{{ externalAccount.sumsByCategory[investmentType].costs | money }}</strong>
                                </td>
                                <td>
                                    <strong>{{ externalAccount.sumsByCategory[investmentType].values | money }}</strong>
                                </td>
                                <td>
                                    <strong>{{ externalAccount.sumsByCategory[investmentType].gainLosses | money }}</strong>
                                </td>
                            </tr>
                            </tbody>
                        </v-simple-table>
                    </v-card>
                    <br>
                    <v-card elevation="0">
                        <v-simple-table dark class="year-position-table-summary">
                            <thead>
                            <tr>
                                <th></th>
                                <th>
                                    Holdings
                                </th>
                                <th colspan="2"></th>
                                <th>
                                    Cost
                                </th>
                                <th>
                                    Value
                                </th>
                                <th>
                                    Gain/Loss
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <th>
                                    Totals
                                </th>
                                <td>
                                    100%
                                </td>
                                <td colspan="2"></td>
                                <td>{{ externalAccount.sums.costs | money }}</td>
                                <td>{{ externalAccount.sums.values | money }}</td>
                                <td>{{ externalAccount.sums.gainLosses | money }}</td>
                            </tr>
                            </tbody>
                        </v-simple-table>
                    </v-card>

                </v-col>

            </v-row>

        </v-card>

    </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";

export default {
    name: "YearToDatePosition",
    props: ['externalAccount'],
    data() {
        return {
            show: false,
        }
    },
    computed: {
        ...mapState({
            positions: state => state.household.positions,
        }),
        ...mapState({
            typeLabels: state => state.constants.typeLabels,
        }),
        ...mapGetters('constants', [
            'getAccountType',
        ]),
    },
}
</script>

<style>

</style>
